/* src/app/modules_v2/finance/payment-card/components/payment-card-form-dialog/payment-card-form-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.pcd-header-text {
  min-width: 0;
  padding-right: 32px;
}
.pcd-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.pcd-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 0 16px;
}
@media (max-width: 560px) {
  .pcd-row {
    grid-template-columns: 1fr;
  }
}
.pcd-uid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
  margin-top: 4px;
}
.pcd-uid__value {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 12px;
  color: #6b7280;
  overflow-wrap: anywhere;
}
.pcd-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.pcd-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.pcd-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
/*# sourceMappingURL=payment-card-form-dialog.component.css.map */
